!function (e, t, n, g, i) { e[i] = e[i] || function () { (e[i].q = e[i].q || []).push(arguments) }, n = t.createElement("script"), tag = t.getElementsByTagName("script")[0], n.async = 1, n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g, tag.parentNode.insertBefore(n, tag) }(window, document, "script", "assets.giocdn.com/2.1/gio.js", "gio");
  gio('init', 'b85a2c100203f931', { manualImp: true });
  gio('send');
  var customerId = ''
  var customerEmail = ''
  if (customerId) {
    gio('setUserId', customerId);
  } else {
    gio('clearUserId');
    gio('visitor.set', 'visitorID_vstr', $.cookie('gr_user_id'));
  }
  if (customerEmail) {
    gio('people.set', 'memberEmail_ppl', customerEmail);
  }